import React from "react";
import { PeekBox, PeekTooltip, useTheme } from "@piiqtechnologies/ui-components";
import { CHART_EDGE_THRESHOLD, focusRingSx } from "./chartScale";
export const RankingBalloonMarker = ({ pct, label, tooltipTitle }) => {
    const theme = useTheme();
    const nearRight = pct > 100 - CHART_EDGE_THRESHOLD;
    const nearLeft = pct < CHART_EDGE_THRESHOLD;
    const bubbleTransform = nearRight ? "translateX(-85%)" : nearLeft ? "translateX(-15%)" : "translateX(-50%)";
    const arrowLeft = nearRight ? "85%" : nearLeft ? "15%" : "50%";
    const tooltipPlacement = nearRight ? "top-end" : nearLeft ? "top-start" : "top";
    const bubble = (React.createElement(PeekBox, { tabIndex: 0, sx: Object.assign(Object.assign({}, focusRingSx(theme)), { position: "absolute", bottom: "100%", mb: 1, left: `${pct}%`, transform: bubbleTransform, bgcolor: "white", border: 2, borderColor: "secondary.main", borderRadius: 3, px: 2.5, py: 1, fontWeight: "fontWeightMedium", color: "text.primary", fontSize: 14, whiteSpace: "nowrap", zIndex: 10, "&::after": {
                content: '""',
                position: "absolute",
                bottom: -12,
                left: arrowLeft,
                transform: "translateX(-50%)",
                width: 0,
                height: 0,
                borderLeft: "12px solid transparent",
                borderRight: "12px solid transparent",
                borderTop: `12px solid ${theme.palette.secondary.main}`,
            } }) },
        label,
        React.createElement(PeekBox, { sx: {
                position: "absolute",
                bottom: -10,
                left: arrowLeft,
                transform: "translateX(-50%)",
                width: 0,
                height: 0,
                borderLeft: "10px solid transparent",
                borderRight: "10px solid transparent",
                borderTop: "10px solid white",
            } })));
    if (!tooltipTitle)
        return bubble;
    return (React.createElement(PeekTooltip, { title: tooltipTitle, placement: tooltipPlacement }, bubble));
};
export default RankingBalloonMarker;
